/**
 * Dependencies.
 */
import Moment from 'moment-timezone';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import DriverModel from '@/api/driver/driver.model';
import TrackingModel from '@/api/tracking/tracking.model';
import VehicleModel from '@/api/vehicle/vehicle.model';

/**
 * Component.
 */
@Component({ name: 'status-unsuccess-component' })
export default class extends Vue {
  /**
   * Property `moment`.
   */
  moment = Moment;

  /**
   * Property `windowHeight`;
   */
  windowHeight = null;

  /**
   * Property `client`.
   */
  @Prop({ type: String })
  client: string;

  /**
   * Property `driver`.
   */
  @Prop({ type: Object })
  driver: DriverModel;

  /**
   * Property `tracking`.
   */
  @Prop({ type: Object })
  tracking: TrackingModel;

  /**
   * Property `vehicle`.
   */
  @Prop({ type: Object })
  vehicle: VehicleModel;

  /**
   * Property `orderType`.
   */
  @Prop({ default: null, type: String })
  orderType: string;

  /**
   * Getter `isDelivery`
   */
  get isDelivery() {
    return this.orderType === 'DELIVERY';
  }

  /**
   * Getter unsuccess status title.
   */
  get unsuccessStatusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter unsuccess status sentence.
   */
  get unsuccessStatusSentence() {
    const { name: driverName = null } = this.driver || {};

    return this.i18n(
      `TRACKING.SENTENCES.STATUS_${
        this.isDelivery ? 'DELIVERY' : 'COLLECT'
      }_UNSUCCESS`,
      false,
      'plain',
      {
        driver: `<b>${driverName || '-'}</b>`
      }
    );
  }

  /**
   * Getter `extraSmallScreenHeight`.
   */
  get extraSmallScreenHeight() {
    return this.windowHeight <= 320;
  }

  /**
   * Lifecycle mounted hook.
   */
  mounted() {
    this.handleOnResize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.handleOnResize);
    });
  }

  /**
   * Lifecycle destroyed hook.
   */
  destroyed() {
    window.removeEventListener('resize', this.handleOnResize);
  }

  /**
   * Handle on resize.
   */
  handleOnResize() {
    this.windowHeight = window.innerHeight;
  }

  /**
   * Handle window height.
   */
  @Watch('windowHeight')
  handlewindowHeight(value) {
    this.windowHeight = value;
  }
}
